import { request } from "./http";

export type EmailDeliveryState = {
  required?: boolean;
  enabled?: boolean;
  verified?: boolean;
  verifiedAt?: string | null;
  email?: string | null;
};

export type MeSettings = {
  emailDelivery?: EmailDeliveryState;
  email_delivery?: EmailDeliveryState;
  [key: string]: any;
};

function normalize(res: any): MeSettings {
  const emailDelivery = res?.emailDelivery || res?.email_delivery || null;
  return {
    ...res,
    emailDelivery,
    email_delivery: emailDelivery,
  };
}

export async function getMeSettings(): Promise<MeSettings> {
  const res = await request<any>("/me/settings", { auth: true });
  return normalize(res);
}

export async function patchMeSettings(body: Partial<MeSettings>): Promise<MeSettings> {
  const res = await request<any>("/me/settings", {
    method: "PATCH",
    body,
    auth: true,
  });
  return normalize(res);
}

export async function setEmailDelivery(enabled: boolean): Promise<MeSettings> {
  const res = await request<any>("/me/settings", {
    method: "PATCH",
    body: { emailDelivery: { enabled } },
    auth: true,
  });
  return normalize(res);
}

export async function requestEmailDeliveryVerify(email: string): Promise<{ ok?: boolean }> {
  return request("/me/settings/email-delivery/verify", {
    method: "POST",
    body: { email },
    auth: true,
  });
}


export type DobStatus = {
  ok?: boolean;
  dob_set?: boolean;
  age_verified_level?: "none" | "self" | "verified";
  adult_verified_at?: string | null;
};

export async function getDobStatus(): Promise<DobStatus> {
  return request<DobStatus>("/me/dob-status", { auth: true });
}

export async function setDateOfBirth(date_of_birth: string): Promise<{ ok?: boolean }> {
  return request("/me/dob", {
    method: "POST",
    body: { date_of_birth },
    auth: true,
  });
}
